import React from 'react';
import PropTypes from 'prop-types';

class tweetComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoaded: false,
			tweetResponse: ''
		};
	}

	componentDidMount() {
		const { tweetid, tweetElementsId } = this.props;
		if( tweetid ) {
			let data = {
				url: 'https://api.twitter.com/1/statuses/oembed.json',
				data: 'id=' + tweetid
			};

			if( !document.getElementById('twitter-wjs') ) {
				let script_widget = document.createElement('script');
				script_widget.id = 'twitter-wjs';
				script_widget.src = '//platform.twitter.com/widgets.js';
				document.head.appendChild(script_widget);
			}

			// Twitter doesn't allow CORS, we need to hack this way
			let _this = this;
			window[ tweetElementsId ] = function( data ) {
				_this.setState({
					isLoaded: true,
					tweetResponse: data
				});
				setTimeout( () => {
					twttr.widgets.load(
						document.getElementById( tweetElementsId )
					);
				}, 10);
			};

			let script = document.createElement('script');
			script.src = `${data.url}?id=${tweetid}&omit_script=true&callback=${tweetElementsId}`;
			script.id = `js_${tweetElementsId}`;
			document.head.appendChild(script);
		}
	}

	cleanAux() {
		delete window[ this.props.tweetElementsId ];
		let element = document.getElementById(`js_${this.props.tweetElementsId}`);
		if( element ) {
			element.parentNode.removeChild( element );
		}
	}

	render() {
		const { tweetElementsId } = this.props;

		if( this.state.isLoaded ) {
			this.cleanAux();
			if( this.state.tweetResponse.html ) {
				return <div className="tweet" id={ tweetElementsId } dangerouslySetInnerHTML={ {  __html: this.state.tweetResponse.html} } />;
			} else {
				return <div className="tweet" id={ tweetElementsId }>An error occurred while retrieving this tweet</div>;
			}
		} else {
			return <div className="tweet" id={ tweetElementsId }>loading tweet...</div>;
		}
	}
}

tweetComponent.propTypes = {
	tweetid: PropTypes.string.isRequired
};


export default tweetComponent;


// WEBPACK FOOTER //
// ./src/components/posts/tweetComponent.js